import privateCremationEH from 'assets/images/tag-images/private-cremation-eh.png';
import privateCremationLW from 'assets/images/tag-images/private-cremation-lw.png';
import privateCremationQLD from 'assets/images/tag-images/private-cremation-qld.png';
import privateCremationNSW from 'assets/images/tag-images/private-cremation-nsw.png';
import privateCremationPAP from 'assets/images/tag-images/private-cremation-pap.png';
import privateCremationBack from 'assets/images/tag-images/private-cremation-back.png';
import communalEH from 'assets/images/tag-images/communal-eh.png';
import communalLW from 'assets/images/tag-images/communal-lw.png';
import communalQLD from 'assets/images/tag-images/communal-qld.png';
import communalNSW from 'assets/images/tag-images/communal-nsw.png';
import communalBack from 'assets/images/tag-images/communal-back.png';
import onHoldEH from 'assets/images/tag-images/on-hold-eh.png';
import onHoldLW from 'assets/images/tag-images/on-hold-lw.png';
import onHoldQLD from 'assets/images/tag-images/on-hold-qld.png';
import onHoldNSW from 'assets/images/tag-images/on-hold-nsw.png';
import onHoldPAP from 'assets/images/tag-images/on-hold-pap.png';
import onHoldBack from 'assets/images/tag-images/on-hold-back.png';

const TAGGING_PROCESS = Object.freeze({
    tagsEH: [
        {
            img: privateCremationEH,
            imgBack: privateCremationBack,
            title: 'Private cremation',
            description: 'The PRIVATE CREMATION tag is to be used when the client wants their pet to be cremated privately in its own chamber and wants to have their ashes returned home. A QR code is displayed on the reverse side of the tag to ensure tracking at every point.'
        },
        {
            img: communalEH,
            imgBack: communalBack,
            title: 'Communal cremation',
            description: 'The COMMUNAL CREMATION tag is to be used when the client wants their pet to be cremated alongside other pets and does not want to have their ashes returned home (NB: the ashes are placed on a site that has no public viewing area for grieving owners to visit).'
        },
        {
            img: onHoldEH,
            imgBack: onHoldBack,
            title: 'Hold',
            description: 'The HOLD tag is to be used when the pet needs to be held at the clinic and not collected e.g. because the client is undecided on a cremation or may want to take the pet home for burial or the account is unpaid.'
        }
    ],
    tagsLW: [
        {
            img: privateCremationLW,
            imgBack: privateCremationBack,
            title: 'Private cremation',
            description: 'The PRIVATE CREMATION tag is to be used when the client wants their pet to be cremated privately in its own chamber and wants to have their ashes returned home. A QR code is displayed on the reverse side of the tag to ensure tracking at every point.'
        },
        {
            img: communalLW,
            imgBack: communalBack,
            title: 'Communal cremation',
            description: 'The COMMUNAL CREMATION tag is to be used when the client wants their pet to be cremated alongside other pets and does not want to have their ashes returned home (NB: the ashes are placed on a site that has no public viewing area for grieving owners to visit).'
        },
        {
            img: onHoldLW,
            imgBack: onHoldBack,
            title: 'Hold',
            description: 'The HOLD tag is to be used when the pet needs to be held at the clinic and not collected e.g. because the client is undecided on a cremation or may want to take the pet home for burial or the account is unpaid.'
        }
    ],
    tagsQLD: [
        {
            img: privateCremationQLD,
            imgBack: privateCremationBack,
            title: 'Private cremation',
            description: 'The PRIVATE CREMATION tag is to be used when the client wants their pet to be cremated privately in its own chamber and wants to have their ashes returned home. A QR code is displayed on the reverse side of the tag to ensure tracking at every point.'
        },
        {
            img: communalQLD,
            imgBack: communalBack,
            title: 'Communal cremation',
            description: 'The COMMUNAL CREMATION tag is to be used when the client wants their pet to be cremated alongside other pets and does not want to have their ashes returned home (NB: the ashes are placed on a site that has no public viewing area for grieving owners to visit).'
        },
        {
            img: onHoldQLD,
            imgBack: onHoldBack,
            title: 'Hold',
            description: 'The HOLD tag is to be used when the pet needs to be held at the clinic and not collected e.g. because the client is undecided on a cremation or may want to take the pet home for burial or the account is unpaid.'
        }
    ],
    tagsNSW: [
        {
            img: privateCremationNSW,
            imgBack: privateCremationBack,
            title: 'Private cremation',
            description: 'The PRIVATE CREMATION tag is to be used when the client wants their pet to be cremated privately in its own chamber and wants to have their ashes returned home. A QR code is displayed on the reverse side of the tag to ensure tracking at every point.'
        },
        {
            img: communalNSW,
            imgBack: communalBack,
            title: 'Communal cremation',
            description: 'The COMMUNAL CREMATION tag is to be used when the client wants their pet to be cremated alongside other pets and does not want to have their ashes returned home (NB: the ashes are placed on a site that has no public viewing area for grieving owners to visit).'
        },
        {
            img: onHoldNSW,
            imgBack: onHoldBack,
            title: 'Hold',
            description: 'The HOLD tag is to be used when the pet needs to be held at the clinic and not collected e.g. because the client is undecided on a cremation or may want to take the pet home for burial or the account is unpaid.'
        }
    ],
    tagsPaP: [
        {
            img: privateCremationPAP,
            imgBack: privateCremationBack,
            title: 'Private cremation',
            description: 'The PRIVATE CREMATION tag is to be used when the client wants their pet to be cremated privately in its own chamber and wants to have their ashes returned home. A QR code is displayed on the reverse side of the tag to ensure tracking at every point.'
        },
        {
            img: communalNSW,
            imgBack: communalBack,
            title: 'Communal cremation',
            description: 'The COMMUNAL CREMATION tag is to be used when the client wants their pet to be cremated alongside other pets and does not want to have their ashes returned home (NB: the ashes are placed on a site that has no public viewing area for grieving owners to visit).'
        },
        {
            img: onHoldPAP,
            imgBack: onHoldBack,
            title: 'Hold',
            description: 'The HOLD tag is to be used when the pet needs to be held at the clinic and not collected e.g. because the client is undecided on a cremation or may want to take the pet home for burial or the account is unpaid.'
        }
    ],
    steps: [
        'Gently place the pet inside a good quality body bag.',
        'Label the pet with a private cremation tag, a communal cremation tag or a hold tag, taking care to ensure the details written on the tag are accurate and clear.',
        'Twist the body bag and use a provided cable tie with the tag onto the ‘neck’ of the body bag.',
        'Write the pet’s details in the Pet Aftercare Journal, taking care to ensure they are accurate and written clearly (NB: any pet not written in the journal must be signed out by a practice staff member upon collection)',
        'Please take great care to label all pets and to do so with the correct information. Cremation is a very final process, there is no going back if errors are made and none of us want to give a client further bad news.'
    ]
});

export default TAGGING_PROCESS;
